/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reset_Variables_NoteInputs */



/**
* | output |
* | --- |
* | "Note: schedule creation may take up to 15 minutes after a box is initialized" |
*
* @param {Reset_Variables_NoteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const reset_variables_note = /** @type {((inputs?: Reset_Variables_NoteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reset_Variables_NoteInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Note: schedule creation may take up to 15 minutes after a box is initialized")
	return /** @type {LocalizedString} */ ("Note : la génération des plannings peut prendre jusqu'à 15 minutes après l'initialisation d'une box")
});